module.exports = __webpack_public_path__ + "img/logo-w.9a48221d.png";